import { useEffect, useState } from "react";
import useTranslation from "next-translate/useTranslation";
import Page from "../../components/Page";
import Avatar from "../../components/Avatar";
import { FaSearch } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaComments } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import ChallengePopup from "../challenge/ChallengePopup";
import Spinner from "../../components/Spinner";
import Popup from "../../components/Popup";
import {
  friendRequest,
  getFriendReqests,
  getFriends,
  useFriends,
  friendStore,
  doFriendSearch,
  loadingReplyFriendRequest,
  setSentFriendRequests,
} from "../../redux/friends";
import { setChatFriend, useFriendChat } from "../../redux/friendChat";
import {
  LEAGUE_NAME_PLACEMENT,
  RelationshipStatus,
} from "@chesshotel/constants";
import { Friend, FullLeagueScore } from "@chesshotel/types";
import Medal from "../../components/Medal";
import {
  getModeNameCapitalFirst,
  getHeighestScore,
  getModeIcon,
} from "../../util/util";
import Link from "next/link";
// import { useChallenges } from "../../ducks/challenges";
import { User } from "@chesshotel/models";
import { userStore, useUser } from "../../redux/user";
import { api } from "../../services/api";
import { showChallengePopup, useLobby } from "../../redux/lobby";
import { FriendWs } from "../../services/wsOutRoutes";

function getSentFriendRequests() {
  api.get("/relationship/sent-friend-requests").then((response) => {
    if (response.data) {
      const friendIds = response.data.map((friend) => friend.friendId);
      setSentFriendRequests(friendIds);
    }
  });
}

function replyFriend(
  friendId: number,
  friendName: string,
  status: RelationshipStatus,
  index: number
) {
  loadingReplyFriendRequest(index);
  console.log("replyFriend");
  api
    .post("/relationship/reply-friend", { friendId, status })
    .then((response) => {
      if (status === RelationshipStatus.ACCEPTED) {
        getFriends();
        console.log("FriendWs.replyFriend(friendName)", friendName);
        FriendWs.replyFriend(friendName);
      }
      getFriendReqests();
    })
    .catch(() => {
      console.log("replyFriend failed");
    });
}

function setFriendSearch(friendSearch: User[]) {
  const { id } = userStore.getState().id;
  const { friendList, sentFriendRequests } = friendStore.getState();
  const friendListIds = friendList.map((friend) => friend.id);

  const filteredSearch = friendSearch.filter((item: User) => {
    if (
      friendListIds.indexOf(item.id) !== -1 ||
      sentFriendRequests.indexOf(item.id) !== -1 ||
      item.id === id
    ) {
      return false;
    } else {
      return true;
    }
  });

  doFriendSearch(filteredSearch);
}

function searchFriends(searchWord: string) {
  api
    .post("/users/search", { searchWord })
    .then((response) => {
      setFriendSearch(response.data);
    })
    .catch(() => {
      console.log("search failed");
    });
}

export default function Friends() {
  const { t } = useTranslation("common");
  const { t: friendsT } = useTranslation("lobby");

  const { memberLoggedIn } = useUser();
  const { challengePopupVisible } = useLobby();

  useEffect(() => {
    if (memberLoggedIn) {
      getFriends();
      getFriendReqests();
      getSentFriendRequests();
    }
  }, [memberLoggedIn]);

  const {
    friendSearch,
    sentFriendRequests,
    friendRequests,
    friendList,
    loadingFriendList,
    loadingFriendRequests,
  } = useFriends();

  // const { sentChallenges } = useChallenges();
  const { unreadMessages } = useFriendChat();

  const [challengeUser, setChallengeUser] = useState(null);
  const [addFriendOpen, setAddFriendOpen] = useState(false);

  function search(word: string) {
    if (word && word.length > 2) {
      searchFriends(word);
    } else {
      setFriendSearch([]);
    }
  }

  function renderPopup() {
    const friends = friendSearch.map((friend: any) => {
      const sent = sentFriendRequests.find((item: any) => item === friend.id);

      return (
        <div className="flex justify-between px-1 py-2" key={`${friend.id}`}>
          <div className="flex items-center space-x-3">
            <Avatar
              id={friend.id}
              avatarId={friend.avatarId}
              avatarType={friend.avatarType}
              fbId={friend.fbId}
              googleId={friend.googleId}
              className="w-9 h-9"
            />
            <div className="font-semibold">{friend.username}</div>
          </div>
          <div className="flex items-center">
            {sent ? (
              <span className="has-tooltip">
                <span className="tooltip">{friendsT("Sent")}</span>
                <div className="w-4 h-4 text-green-400">
                  <FaEnvelope />
                </div>
              </span>
            ) : (
              <button
                className="w-auto h-8 text-green-600 btn btn-icon btn-outline btn-sm"
                onClick={() => friendRequest(friend.id, friend.username)}
              >
                <FaUser />
                <div className="ml-1">+</div>
              </button>
            )}
          </div>
        </div>
      );
    });

    return (
      <Popup onClose={() => setAddFriendOpen(false)} title={t("Add friend")}>
        <div className="flex items-center mb-5">
          <div className="absolute right-10 text-gray-300 pointer-events-none">
            <FaSearch />
          </div>
          <input
            className="p-2 w-full rounded border border-lines"
            autoFocus
            onChange={(e) => search(e.target.value)}
            placeholder={friendsT("Search by username or email")}
          />
        </div>
        <div className="w-full divide-y divide-gray-100">{friends}</div>
        <div className="flex justify-end items-end pt-4 mt-4 w-full">
          <button
            className="btn btn-base btn-blue"
            onClick={() => setAddFriendOpen(false)}
          >
            {t("Close")}
          </button>
        </div>
      </Popup>
    );
  }

  function renderFriendRequests() {
    if (loadingFriendRequests) {
      return (
        <div className="p-4">
          <Spinner blue />
        </div>
      );
    }

    const rows = friendRequests.map((friend: any, index: number) => {
      return (
        <div className="flex justify-between items-center py-3 w-full">
          <div className="flex items-center space-x-3">
            <Avatar
              id={friend.id}
              avatarType={friend.avatarType}
              fbId={friend.fbId}
              avatarId={friend.avatarId}
              googleId={friend.googleId}
              className="w-11 h-11"
            />
            <div className="font-semibold">{friend.username}</div>
          </div>
          <div className="justify-self-end">
            {/* {friend.loading ? (
              <Spinner emptyColor="gray.200" />
            ) : ( */}
            <div className="flex items-center space-x-3">
              <button
                className="btn btn-green btn-xs md:btn-base"
                onClick={() =>
                  replyFriend(
                    friend.id,
                    friend.username,
                    RelationshipStatus.ACCEPTED,
                    index
                  )
                }
              >
                {t("Accept")}
              </button>
              <button
                className="btn btn-red btn-xs md:btn-base"
                onClick={() =>
                  replyFriend(
                    friend.id,
                    friend.username,
                    RelationshipStatus.DECLINED,
                    index
                  )
                }
              >
                {friendsT("Decline")}
              </button>
            </div>
            {/* )} */}
          </div>
        </div>
      );
    });
    if (rows && rows.length > 0) {
      return (
        <div className="p-5 mb-4 bg-gray-100 rounded">
          <div className="mb-3 text-lg font-bold">
            {friendsT("Friend requests")}
          </div>
          <div className="divide-y">{rows}</div>
        </div>
      );
    }
  }

  function challengeFriend({
    id,
    username,
    avatarId,
    avatarType,
    fbId,
    online,
  }: Friend) {
    setChallengeUser({
      id,
      username,
      avatarId,
      avatarType,
      fbId,
      online,
    });
    showChallengePopup(true);
  }

  function renderFriends() {
    const { t } = useTranslation("common");

    const { t: friendsT } = useTranslation("lobby");

    if (loadingFriendList) {
      return (
        <div className="flex items-center w-full">
          <Spinner blue />
        </div>
      );
    } else if (friendList.length === 0) {
      return (
        <div className="flex justify-center items-center py-2 w-full">
          <div className="text-2xl">{friendsT("No friends yet")}</div>
        </div>
      );
    }

    return friendList.map((friend: Friend, index: number) => {
      const isChallenged = false; // sentChallenges.indexOf(friend.username) >= 0;
      const badgeCount = unreadMessages[friend.id] || 0;

      const score: FullLeagueScore = getHeighestScore(friend.scores);

      return (
        <div
          className="flex justify-between items-center py-4 first:pt-0 first:pb-4"
          key={friend.id}
        >
          <div className="flex items-center">
            <Link href={"/user?userId=" + friend.id + "&link=friends"}>
              <Avatar
                avatarType={friend.avatarType}
                id={friend.id}
                fbId={friend.fbId}
                avatarId={friend.avatarId}
                googleId={friend.googleId}
                className="w-11 h-11 hover:opacity-70"
                status={friend.online ? "online" : "offline"}
              />
            </Link>
            <div className="flex flex-col items-start ml-4">
              <div className="mt-1 font-semibold text-md md:text-lg">
                {friend.username}
              </div>
              {score && (
                <span className="has-tooltip">
                  <span className="tooltip">
                    {getModeNameCapitalFirst(score.modeId, t) +
                      " " +
                      friendsT("rating")}
                  </span>
                  <div className="flex items-center space-x-0.5 text-xs md:text-sm">
                    {getModeIcon(score.modeId)}
                    <div>{score.elo}</div>
                  </div>
                </span>
              )}
            </div>
            {score && score.leagueName !== LEAGUE_NAME_PLACEMENT && (
              <div className="hidden md:flex">
                <span className="has-tooltip">
                  <span className="tooltip">
                    {getModeNameCapitalFirst(score.modeId, t) +
                      " " +
                      t(score.leagueName + " league")}
                  </span>
                  <div className="ml-4">
                    <Medal
                      rank={score.rank}
                      leagueName={score.leagueName}
                      size="small"
                      title=""
                    />
                  </div>
                </span>
              </div>
            )}
          </div>
          <div className="flex space-x-1">
            {!isChallenged ? (
              <span className="has-tooltip">
                <span className="tooltip">{t("Invite")}</span>
                <button
                  onClick={() => challengeFriend({ ...friend })}
                  className={`btn btn-icon btn-icon-lg
                    ${friend.online ? "btn-goast" : "btn-disabled"}`}
                  disabled={!friend.online}
                  aria-label={t("Invite")}
                >
                  <FaEnvelope />
                </button>
              </span>
            ) : (
              <span className="has-tooltip">
                <span className="tooltip">{friendsT("Invite sent")}</span>
                <button
                  className="text-green-400 btn btn-icon btn-icon-lg"
                  aria-label={t("Invite")}
                >
                  <FaEnvelope />
                </button>
              </span>
            )}
            <span className="has-tooltip">
              <span className="tooltip">{t("Chat")}</span>
              {badgeCount > 0 && (
                <div
                  className={`absolute left-7 top-2 z-10
                    flex items-center justify-center
                    p-0.5 w-4 h-4
                    text-xs text-white
                    rounded-full bg-red-500 select-none`}
                >
                  {badgeCount}
                </div>
              )}
              <button
                className={`btn btn-icon btn-icon-lg
                    ${friend.online ? "btn-goast" : "btn-disabled"}`}
                disabled={!friend.online}
                onClick={() => setChatFriend(friend.id)}
                aria-label={t("Chat")}
              >
                <FaComments />
              </button>
            </span>
          </div>
        </div>
      );
    });
  }

  const add = (
    <button
      className="btn btn-base btn-blue"
      onClick={() => setAddFriendOpen(true)}
    >
      + {friendsT("Add")}
    </button>
  );
  return (
    <Page title={t("Friends")} icon={<FaUsers />} right={add}>
      {challengePopupVisible && (
        <ChallengePopup
          onClose={() => showChallengePopup(false)}
          friend={{ id: challengeUser.id, username: challengeUser.username }}
        />
      )}
      <div className="p-6">
        {addFriendOpen && renderPopup()}
        {renderFriendRequests()}
        <div className="w-full divide-y divide-gray-100">{renderFriends()}</div>
      </div>
    </Page>
  );
}
